import { DescriptionSection } from './ProductDescription'

export const ProductDescriptionDetails: DescriptionSection[] = [
  {
    title: 'configurator.infobox.quality.title',
    content: 'configurator.infobox.quality.1',
  },
  {
    title: 'configurator.infobox.delivery.title',
    content: [
      'configurator.infobox.delivery.1',
      'configurator.infobox.delivery.2',
    ],
  },
  {
    title: 'configurator.infobox.warranty.title',
    content: [
      'configurator.infobox.warranty.1',
      'configurator.infobox.warranty.2',
    ],
  },
]
